import { UseMutationOptions, useMutation } from '@tanstack/react-query';
import axiosInstance, { getAPIURL } from '../axiosInstance';
import { EventBookingConfirmationEmail } from '../../types/Types';

export const useSendEventBookingConfirmation = (
  options?: UseMutationOptions<void, unknown, EventBookingConfirmationEmail, unknown>
) => {
  return useMutation({
    ...options,
    mutationFn: (data: EventBookingConfirmationEmail) =>
      axiosInstance
        .post(getAPIURL('/Email/SendEventBookingConfirmation'), data)
        .then((res) => res.data),
  });
};
